  <template>
   <b-modal style="padding:15px" size="lg" id="AddFlourWeightModal" ref="modal" title="Add Flour Weight" ok-title="Submit" cancel-title="Close" 
      @hidden= "resetModal()" @ok= "handleOk" :ok-disabled = "this.$refs.AddFlourWeightForm != undefined ? !this.$refs.AddFlourWeightForm.checkValidity() : true">
        <form ref="AddFlourWeightForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
           
            <div class="col-md-12">
               <b-form-group  label="Weight" label-for="type-input" autocomplete="off">
                <b-form-input id="type-input" v-model= "Weight" type = "number"  required></b-form-input>
              </b-form-group>
            </div>
           
          </div>     
        </form>
      </b-modal>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';

export default {
    name: 'AddFlourWeight',
    data(){
        return{
          moduleName:'Add Flour Weight',   
          Weight:0,
         
          CompanyId:null,
        
		}
  },



methods:{
  
   addFlourWeight(){ 
        
     axios.post('/flourweight/Add', 
      {"Weight":Number(this.Weight), "CompanyId":this.$auth.user().companyId})
      .then(res=>{
            if(res.data.status == 1)
            {
                this.$bvModal.msgBoxOk('Flour Weight has been added successfully!', {
                title: 'Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
                 this.$router.go();
            }
            else if(res.data.status == -1)
            {
                this.$bvModal.msgBoxOk(res.data.msg, {
                title: 'Error',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
             
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.AddFlourWeightForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
     
      resetModal() {
        this.Weight = 0;  
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.addFlourWeight()
       
      },

 

  }
	

}
</script>
